import React from "react";
import styled from "styled-components";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import logo from "../assets/logo.png";
import ASites from "../assets/asitesLogoDL.png";

const Footer = () => {
  return (
    <Wrapper>
      <Top>
        <Logo>
          <img src={logo} alt="" />
        </Logo>

        <Menu>
          <a href="/">Home</a>
          <a href="/services">produktet</a>
        </Menu>

        <Socials>
          <a
            href="https://www.instagram.com/pult.ks/"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.instagram.com/pult.ks/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebook />
          </a>
          {/* <a href="https://tiktok.com" target="_blank" rel="noreferrer">
            <FaTiktok />
          </a> */}
        </Socials>
      </Top>

      <Bottom>
        <span>Built by:</span>
        <a
          href="https://www.instagram.com/asitesagency/m"
          target="_blank"
          rel="noreferrer"
        >
          <DevLogo>
            <img src={ASites} alt="" />
          </DevLogo>
        </a>
      </Bottom>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.footer`
  background: #0f0f0f;
  color: white;
  padding: 70px 50px 50px;

  @media (max-width: 768px) {
    padding: 50px 25px 40px;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    text-align: center;
  }
`;

const Logo = styled.div`
  font-weight: bold;
  font-size: 20px;

  img {
    width: 130px;
  }

  @media (max-width: 768px) {
    img {
      width: 110px;
    }
  }
`;

const Menu = styled.div`
  display: flex;
  gap: 30px;

  a {
    color: white;
    text-decoration: none;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 15px;

  a {
    color: white;
    font-size: 20px;
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Bottom = styled.div`
  border-top: 1px solid #333;
  padding-top: 20px;
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  text-align: center;

  a {
    color: white;
    text-decoration: none;
  }
`;

const DevLogo = styled.span`
  font-weight: bold;

  img {
    width: 200px;
  }

  @media (max-width: 768px) {
    img {
      width: 150px;
    }
  }
`;
